import { createRequestTypes, action } from '../utils/actions';
import { REQUEST, SUCCESS, FAILURE } from '../utils/constants';

export const GET_USERS = createRequestTypes('GET_USERS');
export const GET_ACTIVE_RENT_USERS = createRequestTypes('GET_ACTIVE_RENT_USERS');
export const GET_INACTIVE_RENT_USERS = createRequestTypes('GET_INACTIVE_RENT_USERS');
export const GET_ACTIVE_USERS = createRequestTypes('GET_ACTIVE_USERS');
export const GET_INACTIVE_USERS = createRequestTypes('GET_INACTIVE_USERS');
export const GET_FILTERED_USERS = createRequestTypes('GET_FILTERED_USERS');
export const GET_USER = createRequestTypes('GET_USER');
export const CREATE_HOME_USER = createRequestTypes('CREATE_HOME_USER');
export const CREATE_STUDIO_USER = createRequestTypes('CREATE_STUDIO_USER');
export const CREATE_STUDIO_USER_BY_ADMIN = createRequestTypes('CREATE_STUDIO_USER_BY_ADMIN');
export const CREATE_RENTAL_USER = createRequestTypes('CREATE_RENTAL_USER');
export const GET_USER_WITH_GROUPS = createRequestTypes('GET_USER_WITH_GROUPS');
export const GET_USER_RESULTS = createRequestTypes('GET_USER_RESULTS');
export const UPDATE_USER = createRequestTypes('UPDATE_USER');
export const UPDATE_USER_CREDITS = createRequestTypes('UPDATE_USER_CREDITS');
export const UPDATE_USER_BY_ADMIN = createRequestTypes('UPDATE_USER_BY_ADMIN');
export const DELETE_USER = createRequestTypes('DELETE_USER');
export const DELETE_USERS = createRequestTypes('DELETE_USERS');
export const DOWNLOAD_PDF = createRequestTypes('DOWNLOAD_PDF');
export const UPDATE_USER_PASSWORD = createRequestTypes('UPDATE_USER_PASSWORD');
export const UPDATE_USER_PASSWORD_BY_ADMIN = createRequestTypes('UPDATE_USER_PASSWORD_BY_ADMIN');
export const GET_USER_PRODUCTS = createRequestTypes('GET_USER_PRODUCTS');
export const SELECT_USERS = 'SELECT_USERS';
export const SET_USERS_TABLE_FILTER = 'SET_USERS_TABLE_FILTER';
export const SET_ACHIEVEMENTS_TABLE_FILTER = 'SET_ACHIEVEMENTS_TABLE_FILTER';
export const SET_TRAININGS_TABLE_FILTER = 'SET_TRAININGS_TABLE_FILTER';
export const SET_TRAININGS_TABLE_SORTING = 'SET_TRAININGS_TABLE_SORTING';
export const SET_USERS_TABLE_SORTING = 'SET_USERS_TABLE_SORTING';
export const CLEAR_USER = 'CLEAR_USER';
export const IS_BEAUTY_CARE_ADMIN = createRequestTypes('IS_BEAUTY_CARE_ADMIN');

export const getUsers = {
  request: (data) => action(GET_USERS[REQUEST], { data }),
  success: (payload) => action(GET_USERS[SUCCESS], { payload }),
  failure: (payload) => action(GET_USERS[FAILURE], { payload }),
};

export const getActiveRentUsers = {
  request: (data) => action(GET_ACTIVE_RENT_USERS[REQUEST], { data }),
  success: (payload) => action(GET_ACTIVE_RENT_USERS[SUCCESS], { payload }),
  failure: (payload) => action(GET_ACTIVE_RENT_USERS[FAILURE], { payload }),
};

export const getInactiveRentUsers = {
  request: (data) => action(GET_INACTIVE_RENT_USERS[REQUEST], { data }),
  success: (payload) => action(GET_INACTIVE_RENT_USERS[SUCCESS], { payload }),
  failure: (payload) => action(GET_INACTIVE_RENT_USERS[FAILURE], { payload }),
};

export const getActiveUsers = {
  request: (data) => action(GET_ACTIVE_USERS[REQUEST], { data }),
  success: (payload) => action(GET_ACTIVE_USERS[SUCCESS], { payload }),
  failure: (payload) => action(GET_ACTIVE_USERS[FAILURE], { payload }),
};

export const getInactiveUsers = {
  request: (data) => action(GET_INACTIVE_USERS[REQUEST], { data }),
  success: (payload) => action(GET_INACTIVE_USERS[SUCCESS], { payload }),
  failure: (payload) => action(GET_INACTIVE_USERS[FAILURE], { payload }),
};

export const getUser = {
  request: (id) => action(GET_USER[REQUEST], { id }),
  success: (payload) => action(GET_USER[SUCCESS], { payload }),
  failure: (payload) => action(GET_USER[FAILURE], { payload }),
};

export const clearUser = () => ({
  type: CLEAR_USER,
});

export const createHomeUser = {
  request: (data) => action(CREATE_HOME_USER[REQUEST], { data }),
  success: (payload) => action(CREATE_HOME_USER[SUCCESS], { payload }),
  failure: (payload) => action(CREATE_HOME_USER[FAILURE], { payload }),
};

export const createStudioUser = {
  request: (data) => action(CREATE_STUDIO_USER[REQUEST], { data }),
  success: (payload) => action(CREATE_STUDIO_USER[SUCCESS], { payload }),
  failure: (payload) => action(CREATE_STUDIO_USER[FAILURE], { payload }),
};

export const createRentalUser = {
  request: (data) => action(CREATE_RENTAL_USER[REQUEST], { data }),
  success: (payload) => action(CREATE_RENTAL_USER[SUCCESS], { payload }),
  failure: (payload) => action(CREATE_RENTAL_USER[FAILURE], { payload }),
};

export const createStudioUserByAdmin = {
  request: (data) => action(CREATE_STUDIO_USER_BY_ADMIN[REQUEST], { data }),
  success: (payload) => action(CREATE_STUDIO_USER_BY_ADMIN[SUCCESS], { payload }),
  failure: (payload) => action(CREATE_STUDIO_USER_BY_ADMIN[FAILURE], { payload }),
};

export const getUserResults = {
  request: (data) => action(GET_USER_RESULTS[REQUEST], { data }),
  success: (payload) => action(GET_USER_RESULTS[SUCCESS], { payload }),
  failure: (payload) => action(GET_USER_RESULTS[FAILURE], { payload }),
};

export const updateUser = {
  request: (id, data) => action(UPDATE_USER[REQUEST], { id, data }),
  success: (payload) => action(UPDATE_USER[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_USER[FAILURE], { payload }),
};

export const updateUserCredits = {
  request: (id, data) => action(UPDATE_USER_CREDITS[REQUEST], { id, data }),
  success: (payload) => action(UPDATE_USER_CREDITS[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_USER_CREDITS[FAILURE], { payload }),
};

export const updateUserByAdmin = {
  request: (id, data) => action(UPDATE_USER_BY_ADMIN[REQUEST], { id, data }),
  success: (payload) => action(UPDATE_USER_BY_ADMIN[SUCCESS], { payload }),
  failure: (payload) => action(UPDATE_USER_BY_ADMIN[FAILURE], { payload }),
};

export const deleteUser = {
  request: (id) => action(DELETE_USER[REQUEST], { id }),
  success: (payload) => action(DELETE_USER[SUCCESS], { payload }),
  failure: (payload) => action(DELETE_USER[FAILURE], { payload }),
};

export const deleteUsers = {
  request: (id) => action(DELETE_USERS[REQUEST], { id }),
  success: (payload) => action(DELETE_USERS[SUCCESS], { payload }),
  failure: (payload) => action(DELETE_USERS[FAILURE], { payload }),
};

export const downloadPdf = {
  request: () => action(DOWNLOAD_PDF[REQUEST]),
  success: (payload) => action(DOWNLOAD_PDF[SUCCESS], { payload }),
  failure: (payload) => action(DOWNLOAD_PDF[FAILURE], { payload }),
};

export const getUserProducts = {
  request: (data) => action(GET_USER_PRODUCTS[REQUEST], { data }),
  success: (payload) => action(GET_USER_PRODUCTS[SUCCESS], { payload }),
  failure: (payload) => action(GET_USER_PRODUCTS[FAILURE], { payload }),
};

export const isBeautyCareAdmin = {
  request: () => action(IS_BEAUTY_CARE_ADMIN[REQUEST]),
  success: (payload) => action(IS_BEAUTY_CARE_ADMIN[SUCCESS], { payload }),
  failure: (payload) => action(IS_BEAUTY_CARE_ADMIN[FAILURE], { payload }),
};

export const selectUsers = (data) => ({
  type: SELECT_USERS,
  payload: data,
});

export const setUsersTableFilter = (payload) => ({
  type: SET_USERS_TABLE_FILTER,
  payload,
});

export const setAchievementsTableFilter = (payload) => ({
  type: SET_ACHIEVEMENTS_TABLE_FILTER,
  payload,
});

export const setTrainingsTableFilter = (payload) => ({
  type: SET_TRAININGS_TABLE_FILTER,
  payload,
});

export const setTrainingsTableSorting = (payload) => ({
  type: SET_TRAININGS_TABLE_SORTING,
  payload,
});

export const setUsersTableSorting = (payload) => ({
  type: SET_USERS_TABLE_SORTING,
  payload,
});
